import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "phaseWrapper" }
const _hoisted_2 = { class: "sectionWrapper" }
const _hoisted_3 = { class: "titre" }
const _hoisted_4 = { class: "soustitre" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "sectionWrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Synopsis", -1)
const _hoisted_8 = { class: "sectionContent" }
const _hoisted_9 = { class: "sectionWrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Phases conseillées", -1)
const _hoisted_11 = { class: "sectionContent" }
const _hoisted_12 = { class: "sectionWrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Caracteristiques", -1)
const _hoisted_14 = { class: "sectionContent" }
const _hoisted_15 = { class: "sectionWrapper" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Compétences", -1)
const _hoisted_17 = { class: "sectionContent" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "sectionWrapper" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Langages", -1)
const _hoisted_21 = { class: "sectionContent" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "sectionWrapper" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Combat", -1)
const _hoisted_25 = { class: "sectionContent" }
const _hoisted_26 = { class: "sectionWrapper" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Traits", -1)
const _hoisted_28 = { class: "sectionContent" }
const _hoisted_29 = { class: "sectionWrapper" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Avantages", -1)
const _hoisted_31 = { class: "sectionContent" }
const _hoisted_32 = { class: "sectionWrapper" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Materiel", -1)
const _hoisted_34 = { class: "sectionContent" }
const _hoisted_35 = { class: "sectionWrapper" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "sectionTitle" }, "Niveau de vie", -1)
const _hoisted_37 = { class: "sectionContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.phase.titre), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.phase.soustitre), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.phase.synopsis), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.phases_conseillees, (phaseConseillee, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(phaseConseillee), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.caracteristiques, (caracteristique, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(caracteristique), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.competences, (competence, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              innerHTML: competence
            }, null, 8, _hoisted_18))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.langages, (langage, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              innerHTML: langage
            }, null, 8, _hoisted_22))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.combat, (combat, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(combat), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.traits, (trait, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(trait), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phase.avantages, (avantage, key) => {
            return (_openBlock(), _createElementBlock("li", { key: key }, _toDisplayString(avantage), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.phase.materiel), 1)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.phase.niveau_de_vie), 1)
    ])
  ]))
}